import { ThemeOptions } from "@bronte/viewer-api/src/main";
import { createContext } from "react";

export interface IThemeContext {
  currentTheme: ThemeOptions;
  setCurrentTheme: React.Dispatch<ThemeOptions>;
}

export const ThemeContext = createContext<IThemeContext | null>(null);
